exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i#yellow{color:#ffec33}i#blue{color:rgba(44,30,243,.6352941176470588)}i#beige{color:#fad7a0}i#white{color:#fff}i#brown{color:#5c4505}i#golden{color:#d4ac0d}i#gray{color:#566573}i#purple{color:#8f0583}i#black{color:#000}i#silver{color:#bdc3c7}i#red{color:#ec1212}i#green{color:#1f9432}i#other{color:#ebeff3}", ""]);

// exports
